import type { ListTeamsParams } from './api/teamsApi';

export const teamsKeys = {
  all: ['teams'] as const,
  lists: () => [...teamsKeys.all, 'list'] as const,
  list: (params: ListTeamsParams) => [...teamsKeys.lists(), normalize(params)] as const,
  details: () => [...teamsKeys.all, 'detail'] as const,
  detail: (teamId: string) => [...teamsKeys.details(), teamId] as const,
  leaves: (teamId: string) => [...teamsKeys.detail(teamId), 'leaves'] as const,
  queue: (limit?: number) => [...teamsKeys.all, 'queue', limit ?? null] as const,
};

function normalize(p: ListTeamsParams) {
  return {
    limit: p.limit ?? null,
    cursor: p.cursor ?? null,
    status: p.status ?? null,
  } as const;
}
